import React from "react";

import TaskRow from "./TaskRow";
import Button from "@material-ui/core/Button";

import './TaskList.css';

class TaskList extends React.Component {
    constructor(props) {
        super(props);
        // console.log("TaskList:", props);

        this.state = {
            newTask: undefined,
            selectedTask: undefined,
            updatedTime: new Date(),
        }

        this.selectTask = this.selectTask.bind(this);
        this.newTask = this.newTask.bind(this);
        this.cancelNewTask = this.cancelNewTask.bind(this);
        this.createTask = this.createTask.bind(this);
        this.updateTask = this.updateTask.bind(this);
    }

    render() {
        // const tasks1 = this.props.tasks;
        const tasks1 = this.props.metamodel.requirement.tasks(this.props.parent);

        let tasks = (this.state.newTask ? [...tasks1, this.state.newTask] : tasks1);

        const listStyle = {
            listItemStyle: "none",
            marginTop: "0px",
            marginLeft: "0px",
            paddingLeft: "0px"
        };

        return (
            <div className={this.props.showHeader ? "tasks" : ""}>
                {this.props.showHeader &&
                    <h3 className="header">Tasks</h3>
                }
                {tasks && tasks.length > 0 &&
                    <ul style={listStyle}
                        className="task-list"
                    >
                        {
                            Object.keys(tasks || []).map((i) =>
                                <TaskRow
                                    key={tasks[i].type + '/' + tasks[i].id}
                                    globals={this.props.globals}
                                    element={tasks[i]}
                                    user={this.props.user}
                                    users={this.props.users}
                                    userMap={this.props.userMap}
                                    filter={this.props.filter}
                                    values={this.props.metamodel.task.values}
                                    selected={this.state.selectedTask === tasks[i]}
                                    showDate={this.props.filter && this.props.filter.status !== 'To do'}
                                    showDetails={this.props.showDetails}
                                    onSelect={this.selectTask}
                                    update={this.updateTask}
                                    remove={this.props.removeTask}
                                    create={this.createTask}
                                    cancelNewTask={this.cancelNewTask}
                                />
                            )
                        }
                    </ul>
                }
                {!(tasks && tasks.length > 0) && this.props.showNoTasks &&
                    <p>No tasks.</p>
                }
                {this.props.createTask && !this.state.newTask &&
                    <Button
                        variant="contained"
                        className="new"
                        onClick={this.newTask}
                    >
                        Add task...
                    </Button>
                }
            </div>
        );
    }

    selectTask(task) {
        console.log("TaskList.selectTask", task);
        this.setState({
            selectedTask: task,
        });
    }

    // TODO We also have this.props.newTask which is in Requirements.js. Remove that.
    newTask() {
        let values = {
            type: "Task",
            // name: "New task",
            status: "To do",
        };
        if(this.props.filter.user) {
            values.assigned = `User/${this.props.filter.user}`;
        }
        this.setState({
            newTask: values,
        });
    }

    cancelNewTask() {
        console.log("cancelNewTask");
        this.setState({
            newTask: undefined,
        });
    }

    createTask(values) {
        console.log("createTask", values, ", user:", this.props.filter.user);

        this.props.createTask(values).then(this.cancelNewTask);
    }

    updateTask(element, values) {
        console.log("TaskList.updateTask", element, values);

        return this.props.globals.updateElement(element, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    Object.assign(element, result);
                    this.setState({updatedTime: new Date()});
                    if(this.props.updateTasks) {
                        this.props.updateTasks();
                    }
                },
                (error) => {
                    console.error(error);
                }
            )
    }
}

export default TaskList;
